import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import * as styles from './stats-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var StatsCard = _ref => {
  var title = _ref.title,
    values = _ref.values,
    secondaryValue = _ref.secondaryValue,
    secondaryType = _ref.secondaryType,
    highlighted = _ref.highlighted,
    bordered = _ref.bordered,
    className = _ref.className,
    fixedHeight = _ref.fixedHeight;
  var formatNumber = value => {
    if (value === '-') {
      return value;
    }
    return !value || value === '0' ? '-' : parseInt(value, 10).toLocaleString();
  };
  return ___EmotionJSX("div", {
    css: styles.content(highlighted, bordered, fixedHeight),
    className: className
  }, ___EmotionJSX("div", {
    css: styles.title
  }, title), ___EmotionJSX("div", {
    css: styles.columns
  }, values.map(statItem => ___EmotionJSX("div", {
    css: styles.column,
    key: "".concat(statItem.label, "-").concat(statItem.value)
  }, statItem.label && ___EmotionJSX(Fragment, null, ___EmotionJSX("div", {
    css: styles.number(highlighted, statItem.bold)
  }, formatNumber(statItem.value)), ___EmotionJSX("div", {
    css: styles.text
  }, statItem.label))))), Number(secondaryValue) > 0 && ___EmotionJSX("div", {
    css: styles.secondary
  }, "Plus ", ___EmotionJSX("span", {
    css: styles.count
  }, secondaryValue), " propert", Number(secondaryValue) === 1 ? 'y' : 'ies', " ", secondaryType, " as joint agent"));
};
StatsCard.propTypes = {
  title: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    bold: PropTypes.bool
  })),
  secondaryValue: PropTypes.string,
  secondaryType: PropTypes.oneOf(['sold', 'rented']),
  highlighted: PropTypes.bool,
  bordered: PropTypes.bool,
  className: PropTypes.string,
  fixedHeight: PropTypes.bool
};
StatsCard.defaultProps = {
  title: null,
  values: [],
  secondaryValue: null,
  secondaryType: null,
  highlighted: false,
  bordered: false,
  className: '',
  fixedHeight: false
};
export default StatsCard;